import { render, staticRenderFns } from "./RuleBulkCopyMove.vue?vue&type=template&id=1b643a60&scoped=true"
import script from "./RuleBulkCopyMove.vue?vue&type=script&lang=js"
export * from "./RuleBulkCopyMove.vue?vue&type=script&lang=js"
import style0 from "./RuleBulkCopyMove.vue?vue&type=style&index=0&id=1b643a60&prod&lang=css"
import style1 from "./RuleBulkCopyMove.vue?vue&type=style&index=1&id=1b643a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b643a60",
  null
  
)

export default component.exports